import './App.css';
import { Routes, Route } from "react-router-dom";

import Home from './Pages/Home';
import Header from './Components/header/Header';
import Footer from './Components/footer/Footer';
import ScrollToTop from './Components/ScrollToTop';

import ContactUs from './Pages/ContactUs';
import About from './Pages/About';
import Service from './Pages/Service';
import Services from './Pages/Services';
import Product from './Pages/Product';
import ProductDetail from './Pages/ProductDetail';
import TermsAndConditions from './Pages/TermsAndConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Industries from './Pages/Industries';
import ProductDetail2 from './Pages/ProductDetail2';
import Blog from './Pages/Blog';
import BlogDetail from './Pages/BlogDetail';

import PowerInstrumentation from './Pages/PowerInstrumentation';
import GlandsAccessories from './Pages/GlandsAccessories';
import TerminationTools from './Pages/TerminationTools';
import OilGas from './Pages/OilGas';
import Solar from './Pages/Solar';
import Utilities from './Pages/Utilities';
import Construction from './Pages/Construction';
import Industrial from './Pages/Industrial';
import Career from './Pages/Career';
import Enterable from './Pages/Enterable';
import IPConnectors from './Pages/IPConnectors';
import LabellingSystems from './Pages/LabellingSystems';
import CableManagementSystem from './Pages/CableManagementSystem';
import CableTies from './Pages/CableTies';
import HeatShrink from './Pages/HeatShrink';
import GroundPowerSupply from './Pages/GroundPowerSupply';
import InstrumentationBulk from './Pages/InstrumentationBulk ';
import ServiceDetail1 from './Pages/ServiceDetail1';
import ServiceDetail2 from './Pages/ServiceDetail2';
import CableIndustrial from './Pages/CableIndustrial';
import CableCutting from './Pages/CableCutting';
import Transit from './Pages/Transit';

/* Cable Termination Location Pages */
import CTSharjah from './Pages/CTSharjah.jsx';
import CTAbuDhabi from './Pages/CTAbuDhabi.jsx';
import CTAjman from './Pages/CTAjman.jsx';
import CTAAlain from './Pages/CTAlAin.jsx';
import CTDibbaAlFujairah from './Pages/CTDibbaAlFujairah.jsx';
import CTDibbaAlHisn from './Pages/CTDibbaAlHisn.jsx';
import CTDubai from './Pages/CTDubai.jsx';
import CTDubaiIndustrialCity from './Pages/CTDubaiIndustrialCity.jsx';
import CTDubaiInvestmentPark from './Pages/CTDubaiInvestmentPark.jsx';
import CTFujairah from './Pages/CTFujairah.jsx';
import CTJebelAli from './Pages/CTJebelAli.jsx';
import CTKalba from './Pages/CTKalba.jsx';
import CTKhorFakkan from './Pages/CTKhorFakkan.jsx';
import CTMadinatZayed from './Pages/CTMadinatZayed.jsx';
import CTRasAlKhaimah from './Pages/CTRasAlKhaimah.jsx';
import CTRuways from './Pages/CTRuwais.jsx';
import CTUmmAlQuwain from './Pages/CTUmmAlQuwain.jsx';


function App() {
  return (
    <>
      <ScrollToTop />

      <Header />

      <Routes>

        {/* =========================
            MAIN WEBSITE ROUTES
        ========================= */}

        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />

        <Route path="/services" element={<Service />} />

        {/* <Route path="/services" element={<Services />} /> */}

        <Route path="/product" element={<Product />} />

        <Route
          path="/product-detail"
          element={<ProductDetail2 />}
        />

        <Route
          path="/career"
          element={<Career />}
        />

        <Route
          path="/landscape"
          element={<ProductDetail />}
        />

        <Route
          path="/contact-us"
          element={<ContactUs />}
        />

        <Route
          path="/terms-condition"
          element={<TermsAndConditions />}
        />

        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />

        <Route
          path="/industries"
          element={<Industries />}
        />

        <Route
          path="/blog"
          element={<Blog />}
        />

        <Route
          path="/blog/:slug"
          element={<BlogDetail />}
        />


        {/* =========================
            PRODUCT / INDUSTRY ROUTES
        ========================= */}

        <Route
          path="/PowerInstrumentation"
          element={<PowerInstrumentation />}
        />

        <Route
          path="/GlandsAccessories"
          element={<GlandsAccessories />}
        />

        <Route
          path="/TerminationTools"
          element={<TerminationTools />}
        />

        <Route
          path="/oilgas"
          element={<OilGas />}
        />

        <Route
          path="/solar"
          element={<Solar />}
        />

        <Route
          path="/utilities"
          element={<Utilities />}
        />

        <Route
          path="/construction"
          element={<Construction />}
        />

        <Route
          path="/industrial"
          element={<Industrial />}
        />

        <Route
          path="/enterable"
          element={<Enterable />}
        />

        <Route
          path="/ipconnectors"
          element={<IPConnectors />}
        />

        <Route
          path="/LabellingSystems"
          element={<LabellingSystems />}
        />

        <Route
          path="/CableManagementSystem"
          element={<CableManagementSystem />}
        />

        <Route
          path="/Cableties"
          element={<CableTies />}
        />

        <Route
          path="/HeatShrink"
          element={<HeatShrink />}
        />

        <Route
          path="/GroundPowerSupply"
          element={<GroundPowerSupply />}
        />

        <Route
          path="/InstrumentationBulk"
          element={<InstrumentationBulk />}
        />


        {/* =========================
            SERVICE DETAIL ROUTES
        ========================= */}

        <Route
          path="/cable-termination"
          element={<ServiceDetail1 />}
        />

        <Route
          path="/cable-industrial"
          element={<CableIndustrial />}
        />

        <Route
          path="/cable-cutting"
          element={<CableCutting />}
        />

        <Route
          path="/transit-inspection"
          element={<Transit />}
        />

        <Route
          path="/customised-enclosure-solutions"
          element={<ServiceDetail2 />}
        />


        {/* =========================
            CABLE TERMINATION
            LOCATION SEO ROUTES
        ========================= */}

        <Route
          path="/cable-termination-company-in-sharjah"
          element={<CTSharjah />}
        />

        <Route
          path="/cable-termination-company-in-abu-dhabi"
          element={<CTAbuDhabi />}
        />

        <Route
          path="/cable-termination-company-in-ajman"
          element={<CTAjman />}
        />

        <Route
          path="/cable-termination-company-in-al-ain"
          element={<CTAAlain />}
        />

        <Route
          path="/cable-termination-company-in-dibba-al-fujairah"
          element={<CTDibbaAlFujairah />}
        />

        <Route
          path="/cable-termination-company-in-dibba-al-hisn"
          element={<CTDibbaAlHisn />}
        />

        <Route
          path="/cable-termination-company-in-dubai"
          element={<CTDubai />}
        />

        <Route
          path="/cable-termination-company-in-dubai-industrial-city"
          element={<CTDubaiIndustrialCity />}
        />

        <Route
          path="/cable-termination-company-in-dubai-investment-park"
          element={<CTDubaiInvestmentPark />}
        />

        <Route
          path="/cable-termination-company-in-fujairah"
          element={<CTFujairah />}
        />

        <Route
          path="/cable-termination-company-in-jebel-ali"
          element={<CTJebelAli />}
        />

        <Route
          path="/cable-termination-company-in-kalba"
          element={<CTKalba />}
        />

        <Route
          path="/cable-termination-company-in-khor-fakkan"
          element={<CTKhorFakkan />}
        />

        <Route
          path="/cable-termination-company-in-madinat-zayed"
          element={<CTMadinatZayed />}
        />

        <Route
          path="/cable-termination-company-in-ras-al-khaimah"
          element={<CTRasAlKhaimah />}
        />

        <Route
          path="/cable-termination-company-in-ruwais"
          element={<CTRuways />}
        />

        <Route
          path="/cable-termination-company-in-umm-al-quwain"
          element={<CTUmmAlQuwain />}
        />

      </Routes>

      <Footer />
    </>
  );
}

export default App;